<div [formGroup]="repairCodeFilterForm" class="form-content">
  <div class="pure-g">
    <!-- Row 1: Mode + Description -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-multi-select ngDefaultControl label="Mode" fit="medium" placeholder="Select modes" formControlName="repairModeList">
        @for (mode of modeOptions; track mode) {
          <mc-option [value]="mode">{{ mode }}</mc-option>
        }
      </mc-multi-select>
    </div>

    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-input ngDefaultControl label="Description" fit="medium" placeholder="Type to search the options" formControlName="description">
      </mc-input>
    </div>

    <!-- Row 2: Repair Code (full width tag input) -->
    <div class="pure-u-1 p-r-8 p-b-16">
      <app-aems-multiline-tag-input
        label="Repair Code"
        placeholder="Type repair code and press Enter"
        [regex]="repairCodeRegex"
        [transformToUppercase]="true"
        formControlName="repairCodeList">
      </app-aems-multiline-tag-input>
    </div>

    <!-- Row 3: Repair Active + Parts Allowed + Multiple Eq -->
    <div class="pure-u-1 pure-u-md-1-3 p-r-8 p-b-16">
      <mc-checkbox-group legend="Repair Active" fit="medium" orientation="horizontal">
        <mc-checkbox value="Y" label="Y" [checked]="isValueSelected('isActive', 'Y')" (change)="onCheckChange('isActive', 'Y')">
        </mc-checkbox>
        <mc-checkbox value="N" label="N" [checked]="isValueSelected('isActive', 'N')" (change)="onCheckChange('isActive', 'N')">
        </mc-checkbox>
      </mc-checkbox-group>
    </div>

    <div class="pure-u-1 pure-u-md-1-3 p-r-8 p-b-16">
      <mc-checkbox-group legend="Parts Allowed" fit="medium" orientation="horizontal">
        <mc-checkbox value="Y" label="Y" [checked]="isValueSelected('allowParts', 'Y')" (change)="onCheckChange('allowParts', 'Y')">
        </mc-checkbox>
        <mc-checkbox value="N" label="N" [checked]="isValueSelected('allowParts', 'N')" (change)="onCheckChange('allowParts', 'N')">
        </mc-checkbox>
      </mc-checkbox-group>
    </div>

    <div class="pure-u-1 pure-u-md-1-3 p-r-8 p-b-16">
      <mc-checkbox-group legend="Multiple Eq" fit="medium" orientation="horizontal">
        <mc-checkbox value="Y" label="Y" [checked]="isValueSelected('multipleEq', 'Y')" (change)="onCheckChange('multipleEq', 'Y')">
        </mc-checkbox>
        <mc-checkbox value="N" label="N" [checked]="isValueSelected('multipleEq', 'N')" (change)="onCheckChange('multipleEq', 'N')">
        </mc-checkbox>
      </mc-checkbox-group>
    </div>
  </div>
</div>

<div class="utility-buttons">
  <mc-button
    label="Apply filters"
    variant="filled"
    appearance="primary"
    fit="medium"
    (click)="applyFilters()"
    (keydown.enter)="applyFilters()">
  </mc-button>
  <mc-button
    label="Clear filters"
    variant="outlined"
    appearance="neutral"
    fit="medium"
    class="m-r-8"
    (click)="clearFilters()"
    (keydown.enter)="clearFilters()">
  </mc-button>
</div>
